module.exports = __webpack_public_path__ + "img/block7-card3.f3842d35.svg";